import { z } from "zod";

/**
 * Image types a coach may upload to our public storage. Anything else, SVG and
 * HTML included, would run as a page on a DCM domain when opened.
 */
export const COACH_IMAGE_EXTENSIONS = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
} as const;

export type CoachImageMimeType = keyof typeof COACH_IMAGE_EXTENSIONS;

export const coachImageMimeTypeSchema = z.enum(
  Object.keys(COACH_IMAGE_EXTENSIONS) as [
    CoachImageMimeType,
    ...CoachImageMimeType[],
  ],
);

/** Narrows a browser-reported file type, so the upload fails before any request. */
export function toCoachImageMimeType(type: string): CoachImageMimeType {
  const parsed = coachImageMimeTypeSchema.safeParse(type);
  if (!parsed.success) {
    throw new Error("Choose a JPEG, PNG, WebP or GIF image.");
  }
  return parsed.data;
}

/**
 * What a coach image is for. It names the file in storage:
 * `coach/<coachId>/<purpose>-<suffix>.<ext>`.
 */
export const coachImagePurposeSchema = z.enum([
  "hero",
  "main-image",
  "brand-logo",
  "certification",
  "offer",
]);

export type CoachImagePurpose = z.infer<typeof coachImagePurposeSchema>;
